import React from 'react';

export default ({
  width = 20,
  height = 20,
  className = '',
}: {
  width?: number;
  height?: number;
  className?: string;
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id="whatsapp (1) 1" clip-path="url(#clip0_38673_6142)">
      <path
        id="Vector"
        d="M9.99751 0H10.0025C15.5167 0 20 4.48583 20 10C20 15.5142 15.5158 20 10.0025 20C7.96918 20 6.08251 19.3942 4.50251 18.3483L0.658344 19.5767L1.90418 15.8608C0.663779 14.1587 -0.00308816 12.1061 1.07517e-05 10C1.07517e-05 4.48583 4.48418 0 9.99751 0ZM7.13668 5.49667C6.94584 5.04083 6.80084 5.02333 6.51168 5.01167C6.40182 5.00452 6.29177 5.00063 6.18168 5C5.80501 5 5.41168 5.11 5.17334 5.3525C4.88584 5.64667 4.16668 6.33333 4.16668 7.74417C4.16668 9.15333 5.19751 10.5167 5.33584 10.7075C5.48084 10.8975 7.34584 13.8325 10.24 15.0283C12.5042 15.9642 13.1758 15.8775 13.6917 15.7675C14.4442 15.6058 15.3875 15.0508 15.625 14.3817C15.8625 13.7108 15.8625 13.1392 15.7933 13.0175C15.7233 12.8967 15.5325 12.8275 15.2433 12.6825C14.9533 12.5383 13.5467 11.845 13.28 11.7525C13.0192 11.655 12.7708 11.6892 12.5742 11.9667C12.2958 12.3533 12.0242 12.7467 11.8033 12.9833C11.63 13.1683 11.3458 13.1917 11.1092 13.0933C10.7908 12.96 9.89918 12.6483 8.79834 11.6717C7.94751 10.915 7.36834 9.97333 7.20084 9.69083C7.03251 9.40167 7.18334 9.23417 7.31668 9.07833C7.46084 8.89917 7.60001 8.7725 7.74501 8.605C7.89001 8.4375 7.97001 8.35083 8.06334 8.15417C8.16168 7.96333 8.09251 7.76667 8.02251 7.6225C7.95334 7.47833 7.37418 6.06833 7.13668 5.4975V5.49667Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_38673_6142">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
